import api from "./index";

export const getInformaAcademyEventService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(`/home-page`, options);
};

export const getInformaAcademyBannersService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };
  return await api.get(`/academy/banners/event/${params.eventId}`, options);
};

export const getInformaAcademyFilterEventByNameService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(`/home-page?name=${params.eventName}`, options);
};

export const getInformaAcademyFilterEventByYearService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(`/home-page?year=${params.eventYear}`, options);
};
// /academy/* -> Expositor
// /informa-academy/* -> ADMIN

export const getInformaAcademyBannerService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(`/academy/banners/all/event/${params.eventId}`, options);
};

export const getInformaAcademyCourseListService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(
    `/academy/courses/catalog?eventId=${params.eventId}`,
    options
  );
};

export const getInformaAcademyPreviewCourseListService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(
    `/academy/courses/preview?eventId=${params.eventId}`,
    options
  );
};

export const getInformaAcademyBannerCourseListService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(
    `academy/courses/visible?eventId=${params.eventId}`,
    options
  );
};

export const reorderInformaAcademyBannerCourseListService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.put(`academy/courses/order`, params.reorderCourse, options);
};

export const changeVisibilityInformaAcademyBannerCourseListService = async (
  params
) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.put(
    `academy/courses/${params.courseId}/visibility`,
    options
  );
};

export const createInformaAcademyBannerService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.post(`academy/banners`, params.banners, options);
};

export const editInformaAcademyBannerService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.put(
    `academy/banners/homepage/${params.homePageId}`,
    params.banners,
    options
  );
};

export const deleteInformaAcademyBannerService = async (params) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.delete(`academy/banners/${params.bannerId}`, options);
};

export const getInformaAcademyCourseService = async ({
  token,
  courseId,
  eventId,
}) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get(`/academy/event/${eventId}/course/${courseId}`, options);
};

export const getInformaAcademyLessonService = async ({
  token,
  courseId,
  eventId,
  lessonId,
}) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get(
    `/academy/event/${eventId}/course/${courseId}/lesson/${lessonId}`,
    options
  );
};

export const startCourseService = async ({ token, courseId, eventId }) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.post(
    `/academy/event/${eventId}/course/${courseId}/start`,
    options
  );
};

export const getAdminCourseInfoService = async ({ token, courseId }) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get(`/informa-academy/course/${courseId}`, options);
};

export const getAdminLessonsInfoService = async ({ token, courseId }) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get(`/informa-academy/lesson/course/${courseId}`, options);
};

export const getAdminLastestCoursesService = async ({ token }) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.get("academy/course/last10-updated-courses", options);
};

export const getAdminAllBannerEditService = async ({ params }) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${params.token}`,
    },
  };

  return await api.get(`academy/banners/all/event/${params.eventId}`, options);
};
